interface MarkdownNode {
  type: string
  value?: string
  children?: MarkdownNode[]
}

const LINE_BREAK = "\n"

function splitTextOnLineBreaks(node: MarkdownNode): MarkdownNode[] {
  const lines = (node.value ?? "").split(LINE_BREAK)
  if (lines.length === 1) return [node]
  return lines.flatMap((line, index) => {
    const text: MarkdownNode[] = line ? [{ type: "text", value: line }] : []
    return index === 0 ? text : [{ type: "break" }, ...text]
  })
}

function replaceSoftBreaks(node: MarkdownNode): void {
  if (!node.children) return
  node.children = node.children.flatMap((child) => (child.type === "text" ? splitTextOnLineBreaks(child) : [child]))
  node.children.forEach(replaceSoftBreaks)
}

export function remarkSoftBreaksAsLineBreaks() {
  return (tree: MarkdownNode): void => {
    replaceSoftBreaks(tree)
  }
}
